module.exports = __webpack_public_path__ + "img/1731378730112  2段下 (3).5c00f658.png";